import BaseService from "@/boot/BaseService";
class AgendamientoService extends BaseService {
  constructor() {
    super(null, "/agendamiento");
  }
  async index(params) {
    return await this.get("/", params);
  }

  async store(formData) {
    return await this.post("/", {...formData});
  }
}

export default new AgendamientoService();
